import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo from '../Login/git_icon3.png'; // Update the path to your logo if necessary

const Navbar = ({ isLoggedIn, onLogout }) => {
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    try {
      // Call the passed-in logout handler and wait for it to finish
      await onLogout();
      // Navigate to the login page after logout
      navigate('/login');
    } catch (error) {
      // If an error occurs during logout, log it and stay on the current page
      console.error('Logout Error:', error);
    }
  };

  return (
    <nav className="navbar">
      <Link to="/home" className="navbar-brand">
        <img src={logo} alt="Company Logo" className="logo" />
      </Link>
      <ul className="navbar-nav">
        <li className="nav-item">
          <NavLink to="/mapdata" className="nav-link" activeClassName="active">Live Map</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/biofouling-smart-monitoring" className="nav-link" activeClassName="active">Biofouling Smart Monitoring</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/environmental-impact" className="nav-link" activeClassName="active">Environmental Impact</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/vessel-profile" className="nav-link" activeClassName="active">Vessel Profile</NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/ships" className="nav-link" activeClassName="active">Our Fleet</NavLink>
        </li>
        {/* Add CaseStudies menu item */}
        <li className="nav-item">
          <NavLink to="/case-studies" className="nav-link" activeClassName="active">Performance</NavLink>
        </li>
        {/* Conditionally render the logout button based on isLoggedIn */}
        {isLoggedIn && (
          <li className="nav-item">
            <button onClick={handleLogoutClick} className="nav-link logout-button">Logout</button>  
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;
